import AppURLs from "pages/AppInfo/AppUrl";
import React from "react";

const HTTListOverview = React.lazy(() => import("./Main/HTTListOverview"));
const HTTAnalysis = React.lazy(() => import("./Analysis/HTTAnalysis"));
const HTTContract = React.lazy(() => import("./Contract/HTTContract"));
const HTTRequestCompleted = React.lazy(() => import("./Result/HTTRequestCompleted"));
const HTTAccepted = React.lazy(() => import("./Result/HTTAccepted"));
const HTTReportCompleted = React.lazy(() => import("./Result/HTTReportCompleted"));
const HTTBankConfirmed = React.lazy(() => import("./Result/HTTBankConfirmed"));

const httRoutes = {
  // 단일 페이지에 대한 route 정의
  overview: {
    url: "/overview",
    component: HTTListOverview,
    needHttFetching: true, // HttMiddleware 실행 여부
  },
  analysis: {
    url: "/analysis",
    component: HTTAnalysis,
    needHttFetching: true,
  },
  contract: {
    url: "/contract",
    component: HTTContract,
    needHttFetching: true,
  },
  requested: {
    url: "/requested",
    component: HTTRequestCompleted,
    needHttFetching: true,
  },
  accepted: {
    url: "/accepted",
    component: HTTAccepted,
    needHttFetching: true,
  },
  reportCompleted: {
    url: "/report-completed",
    component: HTTReportCompleted,
    needHttFetching: true,
  },
  bankConfirmed: {
    url: "/bank-confirmed",
    component: HTTBankConfirmed,
    needHttFetching: true,
  },

  // 위부터 순서대로 매칭이 진행되므로 root URL 을 마지막에 배치
  // 로그인 없이 접근가능한 intro 페이지를 생성해서 root -> overview 로 변경
  intro: {
    url: "/",
    component: HTTListOverview,
    needHttFetching: true, // HttMiddleware 실행 여부
  },

  // 하위 path tree 를 가지는 경우 index 페이지에 해당하는 component 와 함께 route 를 제공
  /* cardSale: {
    url: "/cardSale",
    component: CardSale,  // 해당 페이지 내에서 하위 path 에 대한 Route 정의 필요
    dataMonthlyUrl: "/cardSale/dataMonthly",  // 하위 path 에 포함될 페이지
    reportDetail: "/cardSale/report/:report_id",  // URL parameter 를 가지는 경우
    needBizData: true,
  }, */
};

export default httRoutes;

export const makeHTTUrl = (targetUrl = "") => {
  return `${AppURLs.htt.root}${targetUrl}`;
};
